import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../context/AppContext";
import { FaChartBar } from "react-icons/fa"; // Icon suggestion; replace if needed
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from "powerbi-client";
import { fetchEmbedReport, fetchSyncWorkflow, fetchSyncWorkflow2, fetchFCReport } from "../../../service/UserDashboard";
import FilterSelect from "../../common/FilterSelect";
import ReactSelector from "../../common/CommonReactSelector";
import { components } from 'react-select';
import { Spinner } from "../../../Spinner";

const translations = {
    en: {
        powerbi_dashboard: "PowerBI Dashboard",
        powerbi_embed: "Your PowerBI dashboard will appear here.",
    },
    ar: {
        powerbi_dashboard: "لوحة معلومات PowerBI",
        powerbi_embed: "سيظهر لوحة معلومات PowerBI هنا.",
    },
};
const Placeholder = (props) => {
    return <components.Placeholder {...props} />;
};

const PowerBIDashboard = () => {
    const { theme, langMode, activityId, departmentId, selectedOrgId , projectId} = useContext(AppContext);   // selectedOrgId - harshit vachhani
    const selectorPortalTarget =
      typeof document !== "undefined" &&
      typeof Element !== "undefined" &&
      document.body instanceof Element &&
      document.body.isConnected
        ? document.body
        : undefined;
    const [embed, setEmbed] = useState(null)
    const [reports, setReports] = useState([])
    const [reportsName, setReportsName] = useState("Select Activity");
    const [selectedReport, setSelectedReport] = useState(null);
    const [isLoader, setIsLoading]= useState(false);  //harshit vachhani

    const containerClass = `bg-white rounded-lg shadow-md 
    ${theme === "dark" ? "bg-gray-800 text-gray-300" : "bg-white text-gray-700"}
    `;

    const handleReportsNameChange = (selectedName) => {
        const selectedWorkflow = reports.find(
            (report) => report.name === selectedName
        );
        if (selectedWorkflow) {
            setReportsName(selectedWorkflow.name);
        }
    };


    const organizationId = Number(localStorage.getItem("selectedOrgId")); // harshit vachhani

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (organizationId === 17 && departmentId === 9) {
                   const response = await fetchSyncWorkflow2(departmentId);
                    setReports(response || []);
                    if(projectId === 19){
                      const defaultReports = [
                          {
                              reportId: "7adaa7ea-1d18-4299-a46f-f8f407df8a53",
                              datasetId: "7174efac-78ef-40d1-a574-efc915b4455a",
                              name: "Default Report",
                          },
                      ];
                      const firstReport = defaultReports[0];
                      setSelectedReport({
                          value: firstReport.reportId,
                          label: firstReport.name,
                          datasetId: firstReport.datasetId,
                      });
                      return;
                    }else{
                         if (response && response.length > 0) {
                        const firstReport = response[0];
                        setSelectedReport({
                            value: firstReport.reportId,
                            label: firstReport.name,
                            datasetId: firstReport.datasetId
                        });
                    }
                    }
                } else {
                    const response = await fetchSyncWorkflow(departmentId);
                    setReports(response || []);
                    if (response && response.length > 0) {
                        const firstReport = response[0];
                        setSelectedReport({
                            value: firstReport.reportId,
                            label: firstReport.name,
                            datasetId: firstReport.datasetId
                        });
                    }
                }
            } catch (error) {
                console.error("Error in fetching workflows:", error);
            }
        };

        fetchData();
    }, [organizationId, departmentId, projectId]);

    useEffect(() => {
        const embedReport = async () => {
            try {
                if (selectedReport) {
                    const embedUrl = await fetchEmbedReport(selectedReport.value, selectedReport.datasetId);
                    setEmbed(embedUrl);
                }
            } catch (error) {
                console.error("Error in embedding report:", error);
            }
        };
        embedReport();
    }, [selectedReport]);

      // Special handling for organization with ID 2 (FC) - harshit vachhani - start
      useEffect(() => {
      if (organizationId !== 2) return;
      
      let isMounted = true;

      const fetchData = async () => {
        setIsLoading(true);
        try {
          const reports = await fetchFCReport();
          if (!isMounted || !Array.isArray(reports) || reports.length === 0)
            return;

          const { reportId, datasetId } = reports[0];
          const embedUrl = await fetchEmbedReport(reportId, datasetId);

          if (isMounted) {
            setEmbed(embedUrl);
          }
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching FC report:", error);
        } finally {
          if (isMounted) {
            setIsLoading(false);
          }
        }
      };

      fetchData();

      return () => {
        isMounted = false;
      };
    }, [organizationId]);
     // Special handling for organization with ID 2 (FC) - harshit vachhani - end


    const Options = Array.isArray(reports)
        ? reports.map((report) => ({ value: report.reportId, label: report.name, datasetId: report.datasetId }))
        : [];

    const handleReportsChange = (selectedOption) => {
        setSelectedReport(selectedOption);
    };
     
    return (
      <div className="flex w-full flex-col gap-2 justify-center">
        <div className="chooseworkflow !my-0 flex w-full sm:w-auto">
          {projectId !== 2 && (
            <div className="w-full sm:w-[260px]">
              <ReactSelector
                defaultValue={reportsName}
                options={Options}
                components={Placeholder}
                placeholder={translations[langMode].workflow}
                onChange={handleReportsChange}
                height="36px"
                menuPortalTarget={selectorPortalTarget}
              />
            </div>
          )}
        </div>
        <div className={containerClass}>
          {/*  // Special handling for organization with ID 2 (FC) - harshit vachhani - start  */}
          {isLoader ? (
            <div className="flex items-center justify-center h-[800px]">
             <Spinner />
            </div>
          ) : (
            // Special handling for organization with ID 2 (FC) - harshit vachhani - end
            <PowerBIEmbed
              embedConfig={{
                type: "report", // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                id: embed?.reportId,
                embedUrl: embed?.embedUrl,
                accessToken: embed?.accessToken,
                tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
                settings: {
                  panes: { filters: { visible: false } },
                  background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    "loaded",
                    function () {
                      console.log("Report loaded");
                    },
                  ],
                  [
                    "rendered",
                    function () {
                      console.log("Report rendered");
                    },
                  ],
                  [
                    "error",
                    function (event) {
                      console.log(event.detail);
                    },
                  ],
                  ["visualClicked", () => console.log("visual clicked")],
                  ["pageChanged", (event) => console.log(event)],
                ])
              }
              cssClassName={
                "reportClass h-[800px] border-none shadow-none bg-[#f3f4f6]"
              }
              getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport;
              }}
            />
          )}
        </div>
      </div>
    );
};

export default PowerBIDashboard;
